export const AccessGroupsActionTypes = {
  PENDING: 'FETCH_ACCESS_GROUPS_PENDING',
  SUCCEEDED: 'FETCH_ACCESS_GROUPS_SUCCEEDED',
  FAILED: 'FETCH_ACCESS_GROUPS_FAILED'
};
export const AccessGroupsUsageActionTypes = {
  PENDING: 'FETCH_ACCESS_GROUPS_USAGE_PENDING',
  SUCCEEDED: 'FETCH_ACCESS_GROUPS_USAGE_SUCCEEDED',
  FAILED: 'FETCH_ACCESS_GROUPS_USAGE_FAILED'
};
export const contactsRegistrationCountActionTypes = {
  PENDING: 'FETCH_CONTACTS_REGISTERATION_COUNT_PENDING',
  SUCCEEDED: 'FETCH_CONTACTS_REGISTERATION_COUNT_SUCCEEDED',
  FAILED: 'FETCH_CONTACTS_REGISTERATION_COUNT_FAILED'
};